export default __webpack_public_path__ + "static/media/camera.4733630d.png";